// Turn a 2-letter ISO country code into its flag emoji, e.g. 'AE' -> 🇦🇪.
export const countryFlag = (cc) => {
    if (!cc || cc.length !== 2) return '🌍'
    try {
        return String.fromCodePoint(
            ...[...cc.toUpperCase()].map((c) => 127397 + c.charCodeAt(0))
        )
    } catch {
        return '🌍'
    }
}

// Human-readable location for a visitor row ("Dubai, AE" / "AE" / "Unknown").
export const locationLabel = (v) => {
    const parts = [v?.city, v?.country].filter(Boolean)
    return parts.length ? parts.join(', ') : 'Unknown location'
}
